import { Injectable } from '@angular/core';

import { Observable, map, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { BaseMiscDomainService } from '@common/domain/base-misc-domain.service';
import { IAuroraState } from '@apps/aurora.state';
import { DepartmentsMiscApiService } from '../api/departments-misc-api.service';
import { Department } from './models/department';

@Injectable({
    providedIn: 'root'
})
export class DepartmentsMiscDomainService extends BaseMiscDomainService
{
    constructor (
        private store: Store<IAuroraState>,
        private departmentsMiscApiService: DepartmentsMiscApiService
    )
    {
        super();
    }

    getDepartments (): Observable<Department[]> {
        return this.departmentsMiscApiService.getDepartments()
            .pipe(
                map(departments => departments.map(d => Department.mapperFromApi(d)))
            );
    }
    
    getDepartment (departmentCode: string) {
        return this.departmentsMiscApiService.getDepartment(departmentCode)
            .pipe(
                map(Department.mapperFromApi)
            );
    }
}
